// components/Gallery.jsx (MODIFIED to remove modal functionality)

import React, { useContext, useCallback, useMemo } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import galleryData from '../data/javascripts/galleryData';
import { useNavigate } from 'react-router-dom';
import HorizontalCardDeck from '../widgets/HorizontalCardDeck';
import ImageViewerCard from '../widgets/ImageViewerCard';
import ActionButton from '../widgets/ActionButton';

// 1. REMOVED lazy and Suspense imports

// Configuration constants
// REMOVED ZOOM_SCALE, ZOOM_PREVIEW_WIDTH/HEIGHT

const Gallery = () => {
    const navigate = useNavigate();
    const { darkMode } = useContext(ThemeContext);
    
    // REMOVED all state related to modal/zoom: selectedImage, zoomPreviewPosition, showZoomPreview
    
    // Memoize theme-based class names for the Gallery component
    const themeClasses = useMemo(() => ({
        sectionBg: 'bg-bg-light dark:bg-bg-dark',
        headingText: 'text-primary dark:text-secondary',
        
        // Main Button styling
        mainButton: 'bg-primary hover:bg-primary/90 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition duration-300',

        // Carousel Button styles
        scrollButtonClasses: `absolute top-1/2 -translate-y-1/2 z-10 p-2 rounded-full 
                              transition duration-300 opacity-90 hover:opacity-100 
                              ${darkMode ? 'bg-gray-700 text-white shadow-xl' : 'bg-white text-gray-800 shadow-lg'}`,
        scrollContainerClasses: 'no-scrollbar',
    }), [darkMode]);

    // --- Modal and Zoom Logic (REMOVED) ---
    // Removed openImageModal, closeImageModal, and handleMouseMove

    // Define a dummy click handler for the card that does nothing, 
    // or you can simplify the ImageViewerCard to handle navigation directly.
    const handleCardClick = useCallback(() => {
        // You can add navigation here if desired, e.g., navigate('/gallery');
        // For now, it simply prevents the modal from opening.
        return; 
    }, []);


    // --- Card Render Function (MODIFIED) ---
    const renderImageViewerCard = useCallback((item) => {
        // Passing the dummy handler or null/undefined, depending on how ImageViewerCard uses 'onClick'
        return <ImageViewerCard item={item} openImageModal={handleCardClick} />;
    }, [handleCardClick]);

    // --- Main Render (MODIFIED) ---
    // REMOVED SuspenseFallback definition

    return (
        <>
            {/* REMOVED the entire {selectedImage && <Suspense> block } */}

            {/* Gallery Section Wrapper */}
            <div id="gallery-wrapper" className={themeClasses.sectionBg}>
                <section id="gallery" className="container mx-auto px-4">
                    {/* Header */}
                    <div className="text-center mb-8">
                        <h2 className={`text-4xl font-bold ${themeClasses.headingText}`}>
                            Experience Gallery
                        </h2>
                    </div>

                    {/* Horizontal Card Deck for Images */}
                    <HorizontalCardDeck
                        items={galleryData}
                        renderItem={renderImageViewerCard}
                        buttonClassName={themeClasses.scrollButtonClasses}
                        containerClassName={themeClasses.scrollContainerClasses}
                    />

                    <div className="text-center mt-12">
                        <ActionButton 
                            text="View Full Gallery" 
                            onClick={() => navigate("/gallery")}
                            className="btn-md"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default React.memo(Gallery);